'use client';

import { SELECTOR } from '@/constants';

export const getMainWrapperElement = () => {
  if (typeof document === 'undefined') return null;

  return document.getElementById(SELECTOR.MAIN_WRAPPER);
};
